import script from "./HklProductDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HklProductDetail.vue?vue&type=script&setup=true&lang=js"

import "./HklProductDetail.vue?vue&type=style&index=0&id=3443bce0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3443bce0"]])

export default __exports__